/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import * as THREE from 'three'
import React, { useRef, useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export function Planes({isPlaneFlying},props) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/Stakeholderplanes.glb')
  const { actions, names } = useAnimations(animations, group)

  useEffect(() => {
    if(isPlaneFlying === true){
    actions[names].reset().fadeIn(2).play()
    actions[names].timeScale = 1.4
    actions[names].setLoop(THREE.LoopOnce)


    }
    else
    {
      actions[names].stop()
    }
  }, [ actions, names, isPlaneFlying])


  return (
    <group ref={group} {...props} dispose={null} position={[0,0,200]}>
      <group name="Scene">
        <mesh
          name="airport_planelanding1_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_planelanding1_geo.geometry}
          material={materials.plane_tex}
          position={[-894.011, 134.115, -467.918]}
          rotation={[-Math.PI, 0.011, -Math.PI]}
          scale={0.025}
        />
        <mesh
          name="airport_planetakeoff1_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_planetakeoff1_geo.geometry}
          material={materials.plane_tex}
          position={[41.613, 1.175, -441.001]}
          scale={0.025}
        />
        <mesh
          name="airport_sightseeingplane1_geo"
          castShadow
          receiveShadow
          geometry={nodes.airport_sightseeingplane1_geo.geometry}
          material={materials['rgp_tex.001']}
          position={[-147.081, 1.824, -483.749]}
          rotation={[0, 0.314, 0]}
          scale={0.036}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/Stakeholderplanes.glb')
